import { useT } from "./i18n";

export function PrivacyPage() {
  const t = useT();

  return (
    <div className="min-h-screen px-6 py-16 max-w-2xl mx-auto">
      <a
        href="/"
        className="text-sm text-[var(--color-text-muted)] hover:text-[var(--color-text)] mb-12 inline-block"
      >
        &larr; {t("backHome")}
      </a>

      <h1 className="text-3xl font-bold mb-8">{t("privacy")}</h1>
      <p className="text-sm text-[var(--color-text-muted)] mb-10">
        {t("lastUpdated")}
      </p>

      <div className="space-y-8 text-[var(--color-text-muted)] leading-relaxed">
        <section>
          <h2 className="text-lg font-semibold text-[var(--color-text)] mb-3">{t("privacyOverviewTitle")}</h2>
          <p>{t("privacyOverview")}</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-[var(--color-text)] mb-3">{t("privacyCollectionTitle")}</h2>
          <p>{t("privacyCollection")}</p>
          <ul className="list-disc list-inside mt-3 space-y-1">
            <li>{t("privacyCollectionItem1")}</li>
            <li>{t("privacyCollectionItem2")}</li>
            <li>{t("privacyCollectionItem3")}</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-[var(--color-text)] mb-3">{t("privacyUsageTitle")}</h2>
          <p>{t("privacyUsage")}</p>
          <ul className="list-disc list-inside mt-3 space-y-1">
            <li>{t("privacyUsageItem1")}</li>
            <li>{t("privacyUsageItem2")}</li>
            <li>{t("privacyUsageItem3")}</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-[var(--color-text)] mb-3">{t("privacyStorageTitle")}</h2>
          <p>{t("privacyStorage")}</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-[var(--color-text)] mb-3">{t("privacyThirdPartyTitle")}</h2>
          <p>{t("privacyThirdParty")}</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-[var(--color-text)] mb-3">{t("privacyChildrenTitle")}</h2>
          <p>{t("privacyChildren")}</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-[var(--color-text)] mb-3">{t("privacyChangesTitle")}</h2>
          <p>{t("privacyChanges")}</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-[var(--color-text)] mb-3">{t("contactUs")}</h2>
          <p>
            {t("privacyContact")}
            <a href="mailto:dreamcontinue.cd@icloud.com">dreamcontinue.cd@icloud.com</a>
          </p>
        </section>
      </div>

      <footer className="mt-16 pt-8 border-t border-[var(--color-border)] text-sm text-[var(--color-text-muted)]">
        {t("copyright")}
      </footer>
    </div>
  );
}
